import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                                <section>
                                    <div className="">
                                        <div className="ilead-rgt people">
                                            <div className="innerpadding">
                                                <div className="innovativeimg">
                                                    <img alt=""
                                                         src={require('@images/How to give feedback.png')}/>
                                                </div>

                                                <div className="ilead-contentarea">

                                                    <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                        <span className="heading">isn't it interesting?</span>
                                                    </div>

                                                    <p>Can you believe what fortune tellers tell you?</p>

                                                    <div className="border_subtitle">Do you trust me?</div>
                                                    <p>Many people are interested in the ‘insights’ that fortune
                                                        tellers, astrologers and palm readers claim to give. However, in
                                                        the absence of real information, many of their techniques rely
                                                        on ‘subjective validation’; a bias in our thinking where we find
                                                        personal or significant meaning in the information presented.
                                                        Combine this with our selective nature about what we pay
                                                        attention to – accepting the information that confirms what we
                                                        think about ourselves and rejecting information that contradicts
                                                        it – it’s easy to see why they are still so popular.</p>


                                                    <div className="lightgreencontentbg keyquestionpad">
                                                        <div className="border_subtitle">Something we can all relate
                                                            to...
                                                        </div>
                                                        <p>In 1948, psychologist Bertram R Forer gave a personality test
                                                            to his students and then gave them a personality analysis
                                                            based on the test’s results.<a className="superscripttext"
                                                                                           href="further_info.php?course=300"><sup>1</sup></a> Each
                                                            student was asked to rate the analysis for accuracy (‘5’
                                                            being excellent and ‘0’ being very poor). The students were
                                                            very impressed with the personality tests and scored an
                                                            average rating of 4.26. Forer then revealed that each
                                                            student had been given the same analysis; a generic set of
                                                            words that couldn’t possibly have been accurate for
                                                            everyone. The reason for this is that we can often not
                                                            scrutinise feedback for its validity if it is vague but
                                                            appears pleasing at face value. This can ultimately undo the
                                                            practical intention of feedback, and is counter-productive
                                                            in many instances.</p>
                                                        <p>More recently, a 2012 study<a className="superscripttext"
                                                                                         href="further_info.php?course=300"><sup>2</sup></a> into
                                                            students’ coursework feedback found that there was a
                                                            difference in the level of critical feedback given to
                                                            minority students. The cause of this was found to be that
                                                            the predominantly white markers had been hesitant to provide
                                                            critical feedback for fear of being racist. This is a
                                                            crucial message to remember with feedback, staying objective
                                                            and being aware of possible biases; even if you think they
                                                            are having a positive impact, they can be having the very
                                                            opposite effect, and negatively impacting on the individual
                                                            be they a student, or an underperforming employee.</p>
                                                    </div>

                                                    <div className="right-btn"><div  onClick={this.props.handleChangePage('Page2')}
                                                                                  className="button-next-previous-done">Next &gt;&gt;</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}